type RecruitCopyInput = {
  recipientName: string;
  isPopupMode: boolean;
  noJobsExist: boolean;
  isBasic: boolean;
};

export function chatLabel(recipientName: string): string {
  return recipientName ? `Start a chat with ${recipientName}` : 'Start a chat';
}

export function upgradeLabel(recipientName: string): string {
  return `Upgrade to Message ${recipientName}`;
}

export function basicTitle({ recipientName, isPopupMode, noJobsExist, isBasic }: RecruitCopyInput): string {
  if (isPopupMode) {
    return '';
  }
  if (isBasic && noJobsExist) {
    return `Ask ${recipientName} to apply by creating your job`;
  }
  return `Ask ${recipientName} to apply for your job`;
}

export function nonBasicTitle({ recipientName, isPopupMode, noJobsExist }: RecruitCopyInput): string {
  if (isPopupMode) {
    return '';
  }
  if (noJobsExist) {
    return 'Start the chat with a job';
  }
  return `Start the chat with ${recipientName}`;
}

export function basicTips({ recipientName, noJobsExist, isBasic }: RecruitCopyInput): string[] {
  if (isBasic && noJobsExist) {
    return [`Easily detail your family's needs in one place, then share with ${recipientName} and other caregivers`];
  }
  return [`We'll let ${recipientName} know you're interested. If available, they'll apply to your job.`];
}

export function premiumTips({ recipientName, isPopupMode, noJobsExist }: RecruitCopyInput): string[] {
  if (isPopupMode) {
    return [`Tell ${recipientName} why they're a good fit for your job`];
  }
  if (noJobsExist) {
    return [`Add a job to your message with ${recipientName} so they know about your schedule and needs`];
  }
  return [
    `Tell ${recipientName} why they're a good fit for your job`,
    'Ask about their availability to set up a call or an in-person interview',
  ];
}
